import React, { useCallback, useState } from "react";
import Report from "../../../models/Report";
import ReportDashboardPage from "./ReportDashboardPage";

function ScopedReportDashboard({ scope, id, title, subtitle }) {
    const [filters, setFilters] = useState({});
    const fetchDashboardManifest = useCallback(
        (params, signal) => {
            if (scope === "entity") {
                return Report.entityDashboardManifest(id, params, signal);
            }

            return Report.memberDashboardManifest(id, params, signal);
        },
        [scope, id],
    );
    const fetchDashboardBatch = useCallback(
        (params, reportBatch, signal) => {
            if (scope === "entity") {
                return Report.entityDashboardBatch(
                    id,
                    params,
                    reportBatch,
                    signal,
                );
            }

            return Report.memberDashboardBatch(
                id,
                params,
                reportBatch,
                signal,
            );
        },
        [scope, id],
    );

    return (
        <ReportDashboardPage
            title={title}
            subtitle={subtitle}
            fetchDashboardManifest={fetchDashboardManifest}
            fetchDashboardBatch={fetchDashboardBatch}
            filters={filters}
            onFiltersChange={setFilters}
            contained={false}
        />
    );
}

export default ScopedReportDashboard;
